import { RouteProvider } from "views/components/Provider";
import { Spinner } from "views/mobile/components/common";
import { iOS } from "lib/isSafari";
import { pathOr } from "ramda";
import { selectLine } from "state/lines/selectors";
import { selectOffice } from "state/offices/selectors";
import { selectUserTicketById } from "state/tickets/selectors";
import { useEffect, useState } from "react";
import { useUpdateUserInfo } from "state/users/hooks";
import React, { useDispatch, useGlobal } from "reactn";
import { useJoinWs } from "hooks/useJoinWs";
import { useTimeAndPeopleAhead } from "hooks/useTimeAndPeopleAhead";

const TicketScreen = ({ match, history, children }) => {
	const { join } = useJoinWs();
	const { office: officeSlug, line: lineSlug, id } = match.params;

	const [update, loading, error, resolved] = useUpdateUserInfo();
	const [userId, setUserId] = useState("");
	const [user] = useGlobal("user");
	const whatsapp = pathOr(false, ["notifications", "whatsapp"], user);
	const push = pathOr(false, ["notifications", "push"], user);
	const never_show_popup_notifications = pathOr(
		false,
		["notifications", "never_show_popup_notifications"],
		user
	);
	const [preferences, setPreferences] = useState({
		whatsapp,
		push,
		never_show_popup_notifications,
	});

	const getLines = useDispatch("requestLines");
	const [ModalState, setModalState] = useState("open");
	const [loadingLines, setLoadingLines] = useState(false);
	const getOffice = useDispatch("requestOffice");
	const [newTicket] = useGlobal("newTicket");
	const sagaRestarted = useDispatch("sagaRestarted");
	const [offices] = useGlobal("officesv2");
	const [moduleOnAttention] = useGlobal("moduleOnAttention");
	const [tickets] = useGlobal("ticketsv2");

	const [hasBeenAttended, setHasBeenAttended] = useState(true);
	// const [called] = useGlobal("called");
	const [onAttention, setOnAttention] = useState("");
	const [unexistTicket, setUnexistTicket] = useState(false);
	const [compare, setCompare] = useState(false);
	const [attentionList, setAttentionList] = useState([]);
	const [turnNumber, setTurnNumber] = useState("");
	const [lines] = useGlobal("linesv2");
	const office = selectOffice(offices, officeSlug);
	const line = selectLine(lines, lineSlug);
	const ticket = selectUserTicketById(tickets, id);
	const isLoggedInTemporary = pathOr(false, ["temporal"], user);
	const isLoggedIn = pathOr(false, ["guest"], user);
	const isVisibleNotificationModal = ModalState === "open";
	const isLoading = pathOr(false, ["loading"], lines);
	const setCloseModal = () => setModalState("closed");
	const {
		wait,
		loading: loadingWait,
		peopleAhead,
	} = useTimeAndPeopleAhead(line, office, ticket);

	useEffect(() => {
		getOffice({ officeSlug });

		getLines({ officeSlug });
	}, [officeSlug]);

	const filterModule =
		moduleOnAttention.length &&
		moduleOnAttention.filter((el) => el.tuid === ticket.tuid);

	useEffect(() => {
		join(officeSlug);
	}, []);

	useEffect(() => {
		if (preferences.push === true)
			update({ ...preferences, onlyPreferences: true });
		if (preferences.never_show_popup_notifications === true)
			update({ ...preferences, onlyPreferences: true });
	}, [preferences]);

	useEffect(() => {
		if (office && line && ticket) {
			if (line === undefined) {
			}
			if (line.attention && ticket.number && line.call) {
				setAttentionList(line.attention);
				setOnAttention(line?.call?.number);
				setTurnNumber(ticket.number);
			}
		}
	}, [office, line, ticket, lines, loadingLines]);

	useEffect(() => {
		if (!iOS) {
			if (
				(window &&
					window.Notification &&
					window.Notification.permission === "default") ||
				(!preferences.push &&
					!preferences.never_show_popup_notifications) ||
				(preferences.push === false &&
					preferences.never_show_popup_notifications === false)
			) {
				setModalState("open");
				return;
			}
			if (
				window &&
				window.Notification &&
				window.Notification.permission === "granted" &&
				!preferences.push &&
				!preferences.never_show_popup_notifications
			) {
				setModalState("open");
				return;
			}
			if (
				window &&
				window.Notification &&
				window.Notification.permission === "granted" &&
				preferences.push === false &&
				preferences.never_show_popup_notifications === false
			) {
				setModalState("open");
				return;
			}
		}
	}, []);

	useEffect(() => {
		return () => {
			if (newTicket) return sagaRestarted();
		};
	}, []);

	useEffect(() => {
		if (isLoading) {
			setLoadingLines(true);
		}
		if (!isLoading) {
			setTimeout(() => setLoadingLines(false), 1500);
		}
	}, [isLoading]);

	useEffect(() => {
		if (officeSlug) getLines({ officeSlug });
	}, [peopleAhead]);
	useEffect(() => {
		const interval = setInterval(() => {
			if (office && office.slug) {
				const { slug: officeSlug } = office;
				getLines({ officeSlug });
				return;
			}
			if (officeSlug) getLines({ officeSlug });
		}, 30000);

		return () => clearInterval(interval);
	}, [office, officeSlug]);

	useEffect(() => {
		const hasBeenAttendedLocal = attentionList.some((tik) => {
			return tik.number === ticket.number;
		});

		if (hasBeenAttendedLocal) {
			setHasBeenAttended(true);
		} else {
			setHasBeenAttended(false);
		}

		return;
	}, [line, lines, ticket, attentionList]);

	useEffect(() => {
		setCompare({
			date1: new Date(ticket && ticket.inserted_at).getDate(),
			date2: new Date().getDate(),
		});
	}, []);

	useEffect(() => {
		if (compare) {
			const unexist =
				compare.date1 < compare.date2 || compare.date1 < compare.date2;
			return setUnexistTicket(unexist);
		}
		setUnexistTicket(false);
	}, [compare]);

	if (!ticket && line && office) history.push("/home");

	if (!ticket || !line || !office) return <Spinner full />;

	return children({
		user,
		history,
		unexistTicket,
		hasBeenAttended,
		loadingLines,
		filterModule,
		turnNumber,
		attentionList,
		onAttention,
		wait,
		loadingWait,
		peopleAhead,
		isLoggedInTemporary,
		userId,
		preferences,
		update,
		push,
		never_show_popup_notifications,
		setPreferences,
		office,
		line,
		ticket,
		isVisibleNotificationModal,
		setCloseModal,
		setModalState,
	});
};

export default RouteProvider(TicketScreen);
